<button
    mat-icon-button
    class="st-live-secondary-cta-button-save-as"
    [matTooltip]="languageSettings.PSTWebSaveViewSettings"
    [matMenuTriggerFor]="menu">
    <mat-icon class="material-symbols-outlined">save_as</mat-icon>
</button>
<!-- Comment this one because we dont have custom fields for rundowns for now -->
<!-- <button
    mat-icon-button
    class="st-live-list-secondary-cta-button-one"
    [disabled]="!isSupervisor()">
    <mat-icon class="material-symbols-outlined">rule</mat-icon>
</button> -->
<button
    mat-icon-button
    class="st-live-secondary-cta-button-copy"
    [matTooltip]="languageSettings.PSTWebCopyViewToClipboard"
    (click)="copyToClipboard()">
    <mat-icon class="material-symbols-outlined">file_copy</mat-icon>
</button>
<mat-menu
    #menu="matMenu"
    class="st-live-secondary-cta-menu">
    <ng-template matMenuContent>
        @if (saveViewSettingsEnabled()) {
            <button
                mat-menu-item
                (click)="saveViewState()">
                {{ languageSettings.PSTWebSaveViewSettings }}
            </button>
        }

        @if (saveAsViewSettingsEnabled()) {
            <!-- <button
                mat-menu-item
                (click)="saveAsViewState()">
                {{ languageSettings.PSTWebSaveAsViewSettings }}
            </button> -->
        }
    </ng-template>
</mat-menu>
